import type { DeliveryOption } from 'src/redux/delivery/types';
import { getDateNDaysFromNow } from './getDateNDaysFromNow';

export const deliveryOptionArrivesOnOrByDate = (option: DeliveryOption, date: string) => {
  if (option.exactDate && option.date) {
    return option.date <= date;
  } else if (option.max) {
    return getDateNDaysFromNow(option.max) <= date;
  }

  return false;
};
